// extracted by mini-css-extract-plugin
module.exports = {"videoCard":"VideoItem_videoCard__1GDoY"};